/**
 * @description SwiperContainer class to initialize Swiper.js
 * @property {Swiper} swiper - Swiper instance
 * @property {HTMLElement} swiperWrapper - Swiper wrapper element
 * @property {NodeList} swiperSlide - Swiper slide elements
 * @property {HTMLElement} swiperPagination - Swiper pagination element
 * @property {HTMLElement} swiperButtonNext - Swiper next button element
 * @property {HTMLElement} swiperButtonPrev - Swiper previous button element
 * @see {@link https://swiperjs.com/} for Swiper.js documentation
 */
class SwiperContainer extends HTMLElement {
    swiperPaginationSelector = '.swiper-pagination';
    swiperButtonNextSelector = '.swiper-button-next';
    swiperButtonPrevSelector = '.swiper-button-prev';

    constructor() {
        super();
        this.swiperWrapper = document.querySelector('.swiper-wrapper');
        this.swiperSlide = document.querySelectorAll('.swiper-slide');
        this.swiperPagination = document.querySelector(this.swiperPaginationSelector);
        this.swiperButtonNext = document.querySelector(this.swiperButtonNextSelector);
        this.swiperButtonPrev = document.querySelector(this.swiperButtonPrevSelector);
        this.createWrapper();
    }

    connectedCallback() {
        window.waitForMod('Swiper')
            .then(this.initSwiper.bind(this))
            .catch(e => { console.error('Error initializing Swiper:', e); });
    }

    createWrapper() {
        this.swiperContainer = document.createElement('div');
        while (this.firstChild)
            this.swiperContainer.appendChild(this.firstChild);
        this.appendChild(this.swiperContainer);
        this.swiperContainer.classList.add('swiper-container');
    }

    initSwiper() {
        if (typeof Swiper !== 'undefined') {
            const opts = {
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                speed: 500,
                ...JSON.parse(this.getAttribute('data-swiper-options')),
            }
            if (this.swiperSlide.length > 1) {
                if (this.swiperPagination)
                    opts.pagination = {
                        el: this.swiperPaginationSelector,
                        clickable: true,
                    }
                if (this.swiperButtonNext && this.swiperButtonPrev)
                    opts.navigation = {
                        nextEl: this.swiperButtonNextSelector,
                        prevEl: this.swiperButtonPrevSelector,
                    }
            }
            this.swiper = new Swiper(this.swiperContainer, opts);
        }
    }
}
customElements.define('swiper-container', SwiperContainer);
